const config = require('./config.yaml');
const text = require('./text.yaml')[templateVars.lang];
const buttonTitle = text.title;

import {initChartByContainerID} from 'component/charts';

class ZoomIn {
	constructor() {
		this.config = config;
		this.text = text;
		this.buttonTitle = this.text.title;
		this.cBoxContainerSelector = '#colorbox';
		this.cBoxLoadedContentSelector = '#cboxLoadedContent';
		this.cBoxCloseSelector = '#cboxClose';

		this.defaultOrientSizeParams = {
			width: '95%',
			height: false
		};

		this.orientSizeParams = {
			width: '95%',
			height: false
		};

		this.configMaxWidth = this.configMaxWidth || '1024px';
		this.maxWidth = ZoomIn.getMaxWidthParam(this.configMaxWidth);
	}

	/**
	 * Обработчик события клика по кнопке zoom-in
	 * @param event
	 * @param element
	 */
	registerEvent(event, element) {
		event.preventDefault();

		this.orientSizeParams = this.defaultOrientSizeParams;

		const $element = $(element);
		const elementType = ZoomIn.getElementType($element);

		switch (elementType) {
			case 'IMAGE':
				this.actionColorBoxImage($element);
				break;
			case 'TABLE':
				this.actionColorBoxTable($element);
				break;
			case 'SVG':
				this.actionColorBoxSVG($element);
				break;
			case 'INTERACTIVE_CHART':
				this.actionColorBoxInteractiveChart($element);
				break;
		}

		global.blurOnLeave(this);
	}

	/**
	 * Настройки пропорций в зависимости от ориентации
	 * @param orient - тип ориентации (width | height)
	 */
	setOrientSize(orient) {
		if (orient == 'width') {
			this.orientSizeParams.width = this.configMaxWidth;
			this.orientSizeParams.height = '95%';
		} else if (orient == 'height') {
			this.orientSizeParams.width = this.configMaxWidth;
			this.orientSizeParams.height = '95%';
		}
	}

	/**
	 * Сокрытие служебных кнопок в увеличенном окне
	 * TODO предусмотреть механизм не-скрытия других кнопок figureButtons по параметру
	 */
	hideFigureButtons() {
		const $cBoxLoadedContent = this.getCBoxLoadedContentBlock();

		if ($cBoxLoadedContent.length) {
			const $excelButton = $cBoxLoadedContent.find('.js-button-excel');
			const $innerFigureButtons = $cBoxLoadedContent.find('.figure-buttons');

			if ($excelButton.data('noHideInZoom') !== undefined) {
				$excelButton
					.siblings()
					.remove();
			} else {
				if ($innerFigureButtons.length) {
					$innerFigureButtons.remove();
					this.updateColorbox({
						width: this.orientSizeParams.width,
						height: this.orientSizeParams.height
					});
				}
			}
		}
	}

	/**
	 * Вызов события обновление размеров ColorBox по переданным параметрам
	 * @param params
	 */
	updateColorbox(params = false) {
		if (params) {
			$.colorbox.resize(params);
		} else {
			$.colorbox.resize({
				width: this.defaultOrientSizeParams['width'],
				height: this.defaultOrientSizeParams['height']
			});
		}
	}

	/**
	 * Возвращает блок с содержимым ColorBox
	 * @returns {*}
	 */
	getCBoxLoadedContentBlock() {
		return $(this.cBoxLoadedContentSelector);
	}

	/**
	 * Возвращает главный блока ColorBox
	 * @returns {*}
	 */
	getCBoxContainer() {
		return $(this.cBoxContainerSelector);
	}

	/**
	 * Выставление атрибута title для кнопки закрытия ColorBox
	 */
	setCloseTitle() {
		$(this.cBoxCloseSelector)
			.attr('title', text.close);
	}

	/**
	 * Вызов ColorBox для содержимого типа Таблица
	 * @param $element
	 */
	actionColorBoxTable($element) {
		if ($element.length) {
			const html = $element[0].outerHTML;
			const containerClasses = $element.data('zoomInClass') ? $element.data('zoomInClass') : false;
			const $cBoxLoadedContent = this.getCBoxLoadedContentBlock();

			$.colorbox({
				maxWidth: this.maxWidth,
				maxHeight: '95%',
				transition: 'elastic',
				speed: 300,
				fadeOut: 300,
				scalePhotos: true,
				className: containerClasses,
				html: html,
				onLoad: () => {
					this.setCloseTitle();
				},
				onComplete: () => {
					this.hideFigureButtons();
					this.updateColorbox({
						width: this.maxWidth,
					});
				}
			});
		}
	}

	/**
	 * Вызов ColorBox для содержимого типа Картинка
	 * @param $element
	 */
	actionColorBoxImage($element) {
		if ($element.length) {
			const html = $element[0].outerHTML;
			const containerClasses = $element.data('zoomInClass') ? $element.data('zoomInClass') : false;
			const $cBoxLoadedContent = this.getCBoxLoadedContentBlock();

			$.colorbox({
				maxWidth: this.maxWidth,
				maxHeight: '95%',
				transition: 'elastic',
				speed: 300,
				fadeOut: 300,
				scalePhotos: true,
				className: containerClasses,
				html: html,
				onLoad: () => {
					this.setCloseTitle();
				},
				onComplete: () => {
					this.hideFigureButtons();

					$cBoxLoadedContent
						.find('img')
						.imgLoad(() => {
							this.updateColorbox();
						});
				}
			});
		}
	}

	/**
	 * Вызов ColorBox для содержимого типа SVG-элемент
	 * @param $element
	 */
	actionColorBoxSVG($element) {
		const $svgContainer = $element.find('[data-svg]');
		let zoomFit = ($svgContainer.data('zoomFit')) ? $svgContainer.data('zoomFit') : false;
		const html = $element[0].outerHTML;
		const containerClasses = $element.data('zoomInClass') ? $element.data('zoomInClass') : false;

		let orientSizeParams = {};

		//Если SVG задан дата атрибут ориентации увеличения, то выставить его в настройки colorbox'a
		if (zoomFit) {
			this.setOrientSize(zoomFit);
		} else {
			//Иначе посчитать относительно пропорций SVG и окна
			let windowRatio = $(window).width() / $(window).height();
			let svgRatio = $svgContainer.data('ratio');

			if (svgRatio > windowRatio) {
				zoomFit = 'width';
				this.setOrientSize(zoomFit);
			} else {
				zoomFit = 'height';
				this.setOrientSize(zoomFit);
			}
		}

		$.colorbox({
			width: this.orientSizeParams['width'],
			height: this.orientSizeParams['height'],
			innerWidth: '500px',
			transition: 'elastic',
			speed: 300,
			fadeOut: 300,
			scalePhotos: true,
			className: containerClasses,
			html: html,
			onLoad: () => {
				this.setCloseTitle();
			},
			onComplete: () => {
				this.hideFigureButtons();
				const $cBoxContainer = this.getCBoxContainer();
				const $cBoxLoadedContent = this.getCBoxLoadedContentBlock();
				const $zoomedDataSvgItem = $cBoxLoadedContent.find('[data-svg]');
				const $zoomedSvgContainer = $zoomedDataSvgItem.parent('.graphic').length
					? $zoomedDataSvgItem : $zoomedDataSvgItem.parent();

				$zoomedSvgContainer.css('width', '100%');
				const containerHeight = Math.ceil($cBoxLoadedContent.height());
				const graphicHeight = Math.ceil($cBoxLoadedContent.find('.graphic').height());

				//Проверка, влезает ли контейнер после увеличения
				if (zoomFit == 'width' && !($svgContainer.data('zoomFit'))) {
					if (containerHeight < graphicHeight) {
						zoomFit = 'height';
					}
				}

				//Если нужно увеличить по высоте
				if (zoomFit == 'height') {
					let containerWidth = false;
					let colorboxWidth = this.maxWidth;

					if ((containerHeight < graphicHeight) || this.maxWidth.match('%')) {
						const contentFullHeight = $cBoxLoadedContent.height();
						let siblingsHeight = 0;

						//Определение высоты соседних элементов контейнера SVG
						$zoomedSvgContainer
							.siblings()
							.each(function () {
								siblingsHeight += $(this).outerHeight();
							});

						//Получение высоты SVG, которую нужно выставить
						let svgHeight = contentFullHeight - siblingsHeight;
						colorboxWidth = false;

						//Выставление размеров "увеличенной" SVG
						$zoomedSvgContainer
							.css('padding', 0)
							.height(svgHeight)
							.width(Math.round(svgHeight * $svgContainer.data('ratio')));

						//Получение размеров контейнера с контентом, по-которому нужно выставить размер ColorBox
						containerWidth = $cBoxLoadedContent
							.find('.graphic')
							.css('display', 'inline-block')
							.width();
					}

					this.updateColorbox({
						innerWidth: containerWidth,
						width: colorboxWidth,
						maxHeight: '95%'
					});
				} else if (zoomFit == 'width') {
					const $svgContainerParent = $svgContainer.parent();

					if (!$svgContainerParent.hasClass('graphic')) {
						$svgContainerParent
							.css({
								width: '100%',
								height: 'auto',
								display: 'inline-block'
							});

						if ($svgContainer.css('padding-bottom').replace('px', '') == 0) {
							$svgContainer.height($svgContainer.width() * $svgContainer.data('ratio'));
						}

						this.updateColorbox(true);
					} else {
						this.updateColorbox(true);
					}
				}
			}
		});
	}

	/**
	 * Вызов ColorBox для содержимого типа Интерактивный график
	 * @param $element
	 */
	actionColorBoxInteractiveChart($element) {
		const $chartContainer = $element.find('.chart');
		const $caption = ($element.has('figcaption')) ? $element.find('figcaption')[0].outerHTML : '';
		const chartID = $chartContainer.attr('id');
		const zoomedChartID = `${chartID}_zoomed`;
		const html = `${$caption}<div class="chart" id="${zoomedChartID}"></div>`;
		const containerClasses = $element.data('zoomInClass') ? $element.data('zoomInClass') : false;
		const chartRatio = $chartContainer.width() / $chartContainer.height();
		let zoomFit = ($chartContainer.data('zoomFit')) ? $chartContainer.data('zoomFit') : false;

		//Если SVG задан дата атрибут ориентации увеличения, то выставить его в настройки colorbox'a
		if (zoomFit) {
			this.setOrientSize(zoomFit);
		} else {
			//Иначе посчитать относительно пропорций SVG и окна
			let windowRatio = $(window).width() / $(window).height();

			if (chartRatio > windowRatio) {
				zoomFit = 'width';
				this.setOrientSize(zoomFit);
			} else {
				zoomFit = 'height';
				this.setOrientSize(zoomFit);
			}
		}

		$.colorbox({
			width: this.orientSizeParams['width'],
			height: this.orientSizeParams['height'],
			innerWidth: '500px',
			transition: 'elastic',
			speed: 300,
			fadeOut: 300,
			scalePhotos: true,
			className: containerClasses,
			html: html,
			onLoad: () => {
				this.setCloseTitle();
			},
			onComplete: () => {
				const $cBoxLoadedContent = this.getCBoxLoadedContentBlock();

				initChartByContainerID(`#${chartID}`, `#${zoomedChartID}`, () => {
					const $cBoxContainer = this.getCBoxContainer();
					const $cBoxLoadedContent = this.getCBoxLoadedContentBlock();
					const $zoomedChartContainer = $cBoxLoadedContent.find('.chart');
					const $zoomedSvgChart = $zoomedChartContainer.find('svg');

					$zoomedSvgChart.css({
						width: '100%',
						height: '100%',
					});

					$zoomedChartContainer.css('width', '100%');

					this.updateColorbox(true);

					const containerHeight = Math.ceil($cBoxLoadedContent.height());
					const chartHeight = Math.ceil($zoomedChartContainer.height());

					//Проверка, влезает ли контейнер после увеличения
					if (zoomFit == 'width' && !($chartContainer.data('zoomFit'))) {
						if (containerHeight < chartHeight) {
							zoomFit = 'height';
						}
					}

					//Если нужно увеличить по высоте
					if (zoomFit == 'height') {
						let containerWidth = false;
						let colorboxWidth = this.maxWidth;

						let chartHeight = $zoomedChartContainer.height();
						colorboxWidth = false;

						//Получение размеров контейнера с контентом, по-которому нужно выставить размер ColorBox
						$zoomedChartContainer
							.css('display', 'inline-block')
							.width();

						this.updateColorbox({
							innerWidth: containerWidth,
							width: colorboxWidth,
							maxHeight: '95%'
						});
					} else if (zoomFit == 'width') {
						this.updateColorbox(true);
					}
				});
			}
		});

		return false;
	}

	/**
	 * Тип обрабатываемого контента
	 * @param $element
	 * @returns {boolean}
	 */
	static getElementType($element) {
		let type = false;

		if ($element.has('[data-svg]').length) {
			type = 'SVG';
		} else if ($element.has('img').length) {
			type = 'IMAGE';
		} else if ($element.has('.chart').length && $element.has('svg').length) {
			type = 'INTERACTIVE_CHART';
		} else if ($element.has('table').length) {
			type = 'TABLE';
		}

		return type;
	}

	/**
	 * Обработка параметра максимальной ширины окошка ColorBox
	 * @param configMaxWidth
	 * @returns {*}
	 */
	static getMaxWidthParam(configMaxWidth) {
		let maxWidth = configMaxWidth;

		if (!configMaxWidth.match('%')) {
			let maxWidthNum = Number(configMaxWidth.replace('px', ''));

			if (maxWidthNum > $(window).width()) {
				maxWidth = '95%';
			}
		}

		return maxWidth;
	}
}

const cZoomIn = new ZoomIn();

/**
 * Добавить кнопку увеличения
 */
function addZoomIn($elements) {
	return $elements.each(function () {
		const $element = $(this);
		const element = $element[0];

		$element.find('.figure-buttons.js-buttons')
			.append(`<button class="button button--zoom js-button-zoom" title="${buttonTitle}">${buttonTitle}</button>`)
			.find('.js-button-zoom')
			.on('click', event => cZoomIn.registerEvent(event, element));

		if (config.contentClickable) {
			$element.find('.graphic__img, .chart')
				.on('click', event => cZoomIn.registerEvent(event, element))
				.addClass('clickable');
		}
	});
}


module.exports.ZoomIn = ZoomIn;
module.exports.addZoomIn = addZoomIn;



// WEBPACK FOOTER //
// ./temp/components/zoom-in/index.js